const Dashboard = () => import('./ListWrapper');

export default [{
  path: '/dashboard',
  name: 'Dashboard',
  component: Dashboard,
}];



// WEBPACK FOOTER //
// ./src/components/Dashboard/index.js